import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import SearchIcon from 'mdi-material-ui/Magnify';

const NavSearch = () => (
  <Button to="/search" component={Link} size="small">
    <SearchIcon />
  </Button>
);

export default NavSearch;
